<template>
<div class="bg-light">
  
  
  <Banner
    title="TrinApps"
    pricing="true"
    level="2"
    bg-color="#fff"
    class="sticky-top"
    />
  
  
  
  <div style="background-color: #ffb300; height: 16px;" />
  
  

  <TrinAppsFamily />



  <b-container
    style="background-color: #ffb300; 
	   font-family: Arial, Helvetica, sans-serif; 
	   font-size: 1.2rem;"
    fluid
    >
    <b-row class="text-center">
      <b-col cols="3" sm="2" offset-sm="1">
	<b-button
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('trinpod')"
	  >
	  <span class="link-ref-text">TrinPod<sup>&trade;</sup></span>
	</b-button>
      </b-col>
      <b-col cols="3" sm="2">
	<b-button
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('launchpad')"
	  >
	  <span class="link-ref-text">LaunchPad</span>
	</b-button>
      </b-col>
      <b-col cols="6" sm="2">
	<b-button
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('cde')"
	  >	  
	  <span class="link-ref-text">CDE</span>
	</b-button>
      </b-col>
      <b-col cols="6" sm="2">
	<b-button
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('crosslink')"
	  >	  
	  <span class="link-ref-text">Crosslink</span>
	</b-button>
      </b-col>
      <b-col cols="6" sm="2">
	<b-button
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('aconex')"
	  >	  
	  <span class="link-ref-text">aconex</span>
	</b-button>
      </b-col> 
    </b-row>
  </b-container>



  <div ref="trinpod" />
  <Layout11 />



  <div ref="launchpad" />
  <div style="background-color: #ffb300; height: 16px;" />
  <Layout12>
    <div slot="intro">
      <h2>All TrinApps come bundled with and are accessed through the Web-Application LaunchPad</h2>
    </div>
    <div slot="icon">
      <b-img
	:src="require('../assets/launchpad.png')"
	style="width: 130px"
	class="mb-2"
	/>
    </div>
    <div slot="title">
      <h1 class="my-auto">LaunchPad</h1>
    </div>
    <div slot="description">
      <p>LaunchPad is the web application you use to access your other TrinApps from.</p>
      <p>Use the LaunchPad to navigate your information in your TrinPod<sup>&trade;</sup> and to launch and use the TrinApps.</p>	  
      <p>In the LaunchPad you can view your information simultaneously with different views and in different apps, creating an effective way of working.</p>
    </div>
    <div slot="buttons">
      <b-button
	size="lg"
	class="btn-yellow mt-5 mx-3"
	style="width: 200px;"
	to="/construction/trinapps/trinapp"
	@click="scrollToTop()"
	>
	LaunchPad
      </b-button>
      <b-button
	size="lg"
	class="btn-orange mt-5 mx-3"
	href="https://trinpod.us/pricing?industry=construction"
	>
	Get Started
      </b-button>
    </div>
  </Layout12>



  <div ref="cde" />
  <div style="background-color: #ffb300; height: 16px;" />



  <Layout01>
    <div slot="icon">
      <b-img :src="require('../assets/trinapp_cde.png')" class="mr-3" style="height: 114px;" />
    </div>
    <div slot="header">TrinApp<sup>&trade;</sup> <span class="red">CDE</span></div>
    <div slot="description">As Construction engineers ourselves, we think you should have 100% ownership and control over your construction data, files, drawings and specs; who has access to your files, where they are stored, and what apps you use to access them.</div>
    <div slot="buttons">
      <b-button
	size="lg"
	class="btn-yellow mx-3"
	style="width: 200px;"
	to="/construction/trinapps/trinapp/cde"
	@click.native="scrollToTop()"
	>
	CDE
      </b-button>
      <b-button
	size="lg"
	class="btn-orange mx-3"
	href="https://trinpod.us/pricing?industry=construction"
	>
	Get Started
      </b-button> 
    </div>
  </Layout01>

  

  <div ref="crosslink" />
  <div style="background-color: #ffb300; height: 16px;" />



  <Layout09>
    <div slot="button">
      <b-button
	size="lg"
	class="btn-yellow mt-5 mx-3"
	style="width: 200px;"
	to="/construction/trinapps/trinapp/cde/crosslink"
	@click.native="scrollToTop()"
	>
	Crosslink
      </b-button>
      <b-button
	size="lg"
	class="btn-orange mt-5 mx-3"
	href="https://trinpod.us/pricing?industry=construction"
	>
	Get Started
      </b-button>
    </div>
  </Layout09>



  <div ref="aconex" />
  <div style="background-color: #ffb300; height: 16px;" />



  <Layout10>
    <div slot="buttons">
      <b-button
	size="lg"
	class="btn-yellow mt-5 mx-3"
	to="/construction/trinpod/aconex"
	@click="scrollToTop()"
	>
	aconex Link
      </b-button>
      <b-button
	size="lg"
	class="btn-orange mt-5 mx-3"
	href="https://trinpod.us/pricing?industry=construction"
	>
	Get Started
      </b-button>
    </div>
  </Layout10>



  <div style="background-color: #ffb300; height: 16px;" />



  <InterestedInNews />



  <div style="background-color: #ffb300; height: 16px;" />



  <b-container
    class="text-center text-light px-5 py-6"
    style="background-color: #08034c;"
    fluid
    >
    <b-row>
      <b-col>
	<h1>Start by</h1>
	<h1>Getting the TrinApp<sup>&trade;</sup> CDE with a TrinPod<sup>&trade;</sup></h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
	<b-button
	  size="lg"
	  class="btn-orange mt-5 mx-3"
	  href="https://trinpod.us/pricing?industry=construction"
	  >
	  Get Started
	</b-button>
      </b-col>
    </b-row>
  </b-container>



  <div style="background-color: #ffb300; height: 16px;" />


  
  <GmxFooter />


  
</div>
</template>

<script>
import GmxFooter from '@/components/footer.vue';
import Banner from '@/components/gmx-banner.vue';
import TrinAppsFamily from '@/components/trinapps-family.vue';
import Layout01 from '@/components/layout-01.vue';
import Layout09 from '@/components/layout-09.vue';
import Layout10 from '@/components/layout-10.vue';
import Layout11 from '@/components/layout-11.vue';
import Layout12 from '@/components/layout-12.vue';
import InterestedInNews from '@/components/interested-in-news.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import * as log from 'loglevel';
export default {
    name: "ConstructionTrinApps",
    components: {
	Banner,
	GmxFooter,
	TrinAppsFamily,
	Layout01,
	Layout09,
	Layout10,
	Layout11,
	Layout12,
	InterestedInNews,
	FontAwesomeIcon
    },
    data () {
	return {
            faCheck
        }
    },
    mounted () {
	window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
	window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
	img: function (image) {
	    require(image)
	},
	onScroll: function () {
	    // Get the current scroll position
	    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
	    if (currentScrollPosition < 0) {
		return
	    }
	    // Stop executing this function if the difference between
	    // current scroll position and last scroll position is less than some offset
	    if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
		return
	    }
	    this.showVerticalRight = currentScrollPosition < this.lastScrollPosition
	    this.showNavbarLogo = currentScrollPosition > this.lastScrollPosition
	    this.lastScrollPosition = currentScrollPosition
	},
	goto: function (refName) {
    	    var element = this.$refs[refName];
	    //log.debug(element);
	    var top = element.offsetTop;
      
	    window.scrollTo(0, top);
	},
	scrollToTop: function () {
	    window.scrollTo(0,0);
        }
    }
}
</script>

